/** PURE_IMPORTS_START ._UsingObservable PURE_IMPORTS_END */
import { UsingObservable } from './UsingObservable';
export var using = UsingObservable.create;
//# sourceMappingURL=using.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/observable/using.js
// module id = 782
// module chunks = 0